import { Button, Wrapper } from "./StyleButtonSubmit";

export default function ButtonSubmit(){
    return(
        <Wrapper>
            <Button type="submit" value="Enviar"/>
        </Wrapper>
    );
}